import { computed } from "vue";
import { createContext } from "@vben-core/shadcn-ui";
export const [injectRenderFormProps, provideFormRenderProps] = createContext("FormRenderProps");
export const useFormContext = (props) => {
  const formRenderProps = injectRenderFormProps();
  const isVertical = computed(
    () => props?.layout ? props.layout === "vertical" : formRenderProps.layout === "vertical"
  );
  const componentMap = computed(() => formRenderProps.componentMap);
  const componentBindEventMap = computed(
    () => formRenderProps.componentBindEventMap
  );
  return {
    componentBindEventMap,
    componentMap,
    isVertical
  };
};
